<template>
    <div class="msgg_box">
        <div class="title_box1_training">
        </div>
        <div class="one_nav_msg">
            <div class="big_line1">
                <div class="small_line2"></div>
            </div>
            <div class="textbook_title">首页 > 联系我们</div>
        </div>
        <div class="contact_title">浙江省药品信息宣传和发展服务中心</div>
        <div class="contact_content">
            <div class="text">
                联系单位：浙江省药品信息宣传和发展服务中心<br />
                通讯地址：杭州市莫干山路文北巷27号623室<br />
                邮编：310000<br />
                联系电话：0571-88903229，0571-88903230，0571-88903228<br />
                工作时间：上午 8:30-11:30<br />
                下午14:00-17:30（夏令时14:30-18:00）  周末、节假日不办公<br />
                传  真：0571-88903294<br />
                <!-- <span style="color:red">技术支持QQ: 1679260696</span> -->
            </div>
            <img class="img1" src="https://medoss.oss-cn-shanghai.aliyuncs.com/uploads/1623210930960.png" alt="">
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
    data() {
        return {
        };
    },
    methods: {}
};
</script>

<style scoped>
@import url("../../../assets/css/licss/training.css");
.contact_title{
    font-size: 24px;
    font-weight: bold;
    color: #1A1A1A;
    border-bottom:1px solid #C8C8C8;
    line-height: 80px;
    text-align: center;
    width: 90%;
    margin:-18px auto 0;
}
.contact_content{
    width: auto;
    text-align: center;
}
.contact_content .text{
    margin:10px 0 30px;
    display: inline-block;
    text-align: left;
    line-height: 42px;
    font-size: 16px;
    color: #4D4D4D;
}
.title_box1_training{
    margin:0 auto;
}
.msgg_box{
    box-shadow: none;
}
.img1{
    width: 861px;
    height: 276.5px;
}
</style>